import * as React from 'react';
import { AppContext, IAppContext, IFormStateBase } from '../Types/Intyg.types';
import Heading from '../FormSections/Heading';
import ValjYrke from '../FormSections/ValjYrke';
import FormDivider from '../FormSections/FormDivider';
import SprakForIntyget from '../FormSections/SprakForIntyget';
import TaEmotIntyget from '../FormSections/TaEmotIntyget';
import Personuppgifter from '../FormSections/Personuppgifter';
import Adressuppgifter from '../FormSections/Adressuppgifter';
import SubmitButton from '../FormSections/SubmitButton';
import Villkor from '../FormSections/Villkor';
import { ApplicationType, Section } from '../Types/Intyg.enums';
import DeleteAnsokan from '../FormSections/DeleteAnsokan';
import { FormBase } from '../Types/FormBase';
import YrkeSpecificInforuta from '../FormSections/YrkeSpecificInforuta';

export interface ILegitimationInomEUProps {}

export interface ILegitimationInomEUState extends IFormStateBase {}

export class LegitimationInomEU extends FormBase<ILegitimationInomEUProps, ILegitimationInomEUState> {
  static contextType = AppContext;
  constructor(props: ILegitimationInomEUProps) {
    super(props);

    this.state = { isFormValid: false };
  }

  public render() {
    const appContext = this.context as IAppContext;

    return (
      <>
        <Heading />
        <ValjYrke ref={this.sectionRefMap.get(Section.ValjYrke) as React.RefObject<ValjYrke>} />
        <YrkeSpecificInforuta />
        <FormDivider />
        <SprakForIntyget ref={this.sectionRefMap.get(Section.SprakForIntyget) as React.RefObject<SprakForIntyget>} />
        <TaEmotIntyget ref={this.sectionRefMap.get(Section.TaEmotIntyget) as React.RefObject<TaEmotIntyget>} />
        <FormDivider />
        <Personuppgifter ref={this.sectionRefMap.get(Section.Personuppgifter) as React.RefObject<Personuppgifter>} />
        <FormDivider />
        {appContext.model.skickaPost && (
          <>
            <Adressuppgifter
              ref={this.sectionRefMap.get(Section.Adressuppgifter) as React.RefObject<Adressuppgifter>}
            />
            <FormDivider />
          </>
        )}
        {<Villkor ref={this.sectionRefMap.get(Section.Villkor) as React.RefObject<Villkor>} />}
        <SubmitButton isEnabled={this.state.isFormValid} />
        <FormDivider />
        {appContext.applicationType === ApplicationType.Eservice && <DeleteAnsokan />}
      </>
    );
  }
}
